import {Theme} from "@mui/material";
import {SxType} from "@baseTypes/sx/sxTypes";

const CHANGED = (theme: Theme) => theme.palette.mode === 'dark' ? '#FFB74D' : '#B95C00'
const OUTDATED = (theme: Theme) => theme.palette.mode === 'dark' ? '#E57373' : '#C62828'

export const sx: SxType = {
	root: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: '6px',
		minWidth: 0,
		maxWidth: '100%',
		px: '10px',
		py: '3px',
		borderRadius: '999px',
		fontSize: '12px',
		fontWeight: 600,
		lineHeight: '16px',
		color: '#0C6DDF',
		bgcolor: 'rgba(12, 109, 223, 0.1)',
	},
	// in a table row the badge would be noise; the title reads as plain text
	compact: {
		px: 0,
		py: 0,
		fontWeight: 400,
		color: 'text.primary',
		bgcolor: 'transparent',
	},
	iconOnly: {
		gap: '4px',
		px: '6px',
		cursor: 'help',
	},
	title: {
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
	mark: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: '2px',
		flexShrink: 0,
		whiteSpace: 'nowrap',
	},
	markIcon: {
		fontSize: '17px',
	},
	diverged: {
		color: CHANGED,
		cursor: 'help',
	},
	outdated: {
		color: OUTDATED,
		cursor: 'pointer',
		'&:hover': {
			textDecoration: 'underline',
		},
	},
}
